import Vue from 'vue'

import en from './messages/en'
import sw from './messages/sw'

const SUPPORTED_LOCALES = ['en', 'sw']
const STORAGE_KEY = 'altezzaLocale'
const messages = { en, sw }

function initialLocale() {
  const stored = localStorage.getItem(STORAGE_KEY)
  return SUPPORTED_LOCALES.includes(stored) ? stored : 'en'
}

export const localeState = Vue.observable({ locale: initialLocale() })

function resolveMessage(locale, key) {
  return key.split('.').reduce((value, part) => value && value[part], messages[locale])
}

function interpolate(message, params) {
  return String(message).replace(/\{(\w+)\}/g, (match, key) => (
    Object.prototype.hasOwnProperty.call(params, key) ? params[key] : match
  ))
}

export function translate(key, params = {}, fallback = '') {
  const localized = resolveMessage(localeState.locale, key)
  const english = resolveMessage('en', key)
  return interpolate(localized || english || fallback || key, params)
}

export function translateChoice(group, item, fallback = '') {
  const code = typeof item === 'string' ? item : item?.code
  const name = typeof item === 'object' ? item?.name : fallback
  return code ? translate(`${group}.${code}`, {}, name || code) : (name || fallback)
}

export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return
  localeState.locale = locale
  localStorage.setItem(STORAGE_KEY, locale)
  document.documentElement.lang = locale
  const titleKey = document.body.dataset.titleKey
  if (titleKey) document.title = `${translate(titleKey)} | Altezza Board`
}

export function currentLocale() {
  return localeState.locale
}

export function localeTag() {
  return localeState.locale === 'sw' ? 'sw-TZ' : 'en-US'
}

export function formatLocalizedDate(value, options) {
  if (!value) return translate('common.notSpecified')
  const normalized = /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value
  const date = new Date(normalized)
  if (Number.isNaN(date.getTime())) return String(value)
  return new Intl.DateTimeFormat(localeTag(), options).format(date)
}

function setSelectLabel(element, binding) {
  const combobox = element.querySelector('[role="combobox"]')
  if (combobox) combobox.setAttribute('aria-label', binding.value)
}

export function installI18n() {
  document.documentElement.lang = localeState.locale
  Vue.prototype.$localeState = localeState
  Vue.prototype.$t = translate
  Vue.prototype.$choice = translateChoice
  Vue.prototype.$setLocale = setLocale
  Vue.directive('localized-select-label', {
    inserted: setSelectLabel,
    update: setSelectLabel,
  })
}
